import { RouteName } from '@/app/@types/routerName';

enum PageId {
  HOME = 'HOME',
  PHOTOS = 'FOTOS',
  E_PROD = 'EPROD',
  REPORTS = 'RELAT',
  VIEWS = 'VISOES',
  BLOCKS = 'BLOCOS',
  INDICATORS = 'INDIC',
  ART_DECOUPAGE = 'DECART',
  WEEKLY_SCRIPTS = 'ROTSEM',
  OPERATION_PANEL = 'PAINEL',
  SCRIPT_PLANNING = 'PLANROT',
  BASIC_DECOUPAGE = 'DECBASIC',
  COSTUME_DECOUPAGE = 'DECFIG',
  CHAPTERS_AND_SCENES = 'CAPCEN',
  CAST_UNAVAILABILITY = 'INDELEN',
  CONTINUITY_DECOUPAGE = 'DECCONT',
  SPECIAL_EFFECTS_DECOUPAGE = 'DECEFESP',
}

const PAGE_MAPPINGS: { name: RouteName; id: PageId }[] = [
  { name: 'Inicio', id: PageId.HOME },
  { name: 'Visões', id: PageId.VIEWS },
  { name: 'Fotos', id: PageId.PHOTOS },
  { name: 'E-Prod', id: PageId.E_PROD },
  { name: 'Blocos', id: PageId.BLOCKS },
  { name: 'Relatórios', id: PageId.REPORTS },
  { name: 'Indicadores', id: PageId.INDICATORS },
  { name: 'E-Prod', id: PageId.OPERATION_PANEL },
  { name: 'E-Prod', id: PageId.OPERATION_PANEL },
  { name: 'Decupagem de Arte', id: PageId.ART_DECOUPAGE },
  { name: 'Decupagem Básica', id: PageId.BASIC_DECOUPAGE },
  { name: 'Roteiros da Semana', id: PageId.WEEKLY_SCRIPTS },
  { name: 'Capítulos e Cenas', id: PageId.CHAPTERS_AND_SCENES },
  { name: 'Decupagem de Figurino', id: PageId.COSTUME_DECOUPAGE },
  { name: 'Planejamento de Roteiros', id: PageId.SCRIPT_PLANNING },
  { name: 'Decupagem de Continuidade', id: PageId.CONTINUITY_DECOUPAGE },
  { name: 'Indisponibilidade de Elenco', id: PageId.CAST_UNAVAILABILITY },
  { name: 'Decupagem de Efeitos Especiais', id: PageId.SPECIAL_EFFECTS_DECOUPAGE },
];

function getPageId(title: string): PageId {
  const mapping = PAGE_MAPPINGS.find((mapping) => title.includes(mapping.name));
  return mapping ? mapping.id : PageId.HOME;
}

export { type PageId, getPageId };
